import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile, faTrashAlt } from "@fortawesome/free-solid-svg-icons";

import Button from "../../components/Button";
import type { UploadFile } from "../../components/Upload";

interface SelectedFilesPreviewProps {
    uploadFiles: UploadFile[],
    removeFileWithName: (fileName: string) => void;
}

function ImagePreview({ file }: { file: UploadFile }) {
    return (<>
        <div>{`${file.file.name} - ${file.file.size / 1000}KB`}</div>
        <img src={file.previewUrl} alt="Thumbnail preview of the file to be uploaded" className="image" />
    </>)
}

function DocumentPreview({ file }: { file: UploadFile }) {
    return (<>
        <div style={{ maxWidth: "100%", wordBreak: "break-word" }}>
            {`${file.file.name} - ${file.file.size / 1000}KB`}
        </div>
        <FontAwesomeIcon icon={faFile} />
    </>);
}

function SelectedFilePreview({ file: uploadFile, removeFileWithName }: { file: UploadFile, removeFileWithName: (fileName: string) => void }) {
    function handleRemoveFile(e: any, fileName: string) {
        e.stopPropagation();
        removeFileWithName(fileName);
    }

    return (
        <div className="image__wrap">
            <Button action="tertiary" onClick={(e) => handleRemoveFile(e, uploadFile.file.name)}>
                <FontAwesomeIcon icon={faTrashAlt} />
            </Button>
            {uploadFile.file.type.includes("image") ? (
                <ImagePreview file={uploadFile} />
            ) : (
                <DocumentPreview file={uploadFile} />)
            }
        </div>
    );
}

export default function SelectedFilesPreview({ uploadFiles, removeFileWithName }: SelectedFilesPreviewProps) {
    return (uploadFiles.length) > 0 ? (
        <div className="create-form__section">
            <h4>Previews</h4>
            <div className="gallery">
                {
                    // Assumes upload file names are unique. Otherwise reinforce the key with extra entropy.
                    uploadFiles.map((uploadFile) => <SelectedFilePreview key={uploadFile.file.name} file={uploadFile} removeFileWithName={removeFileWithName} />)
                }
            </div>
        </div>
    ) : (<></>);
}
